import { useState } from 'react';
import { PaymentProfile } from '../types';

let selectedRecords: PaymentProfile[] = [];
const listeners: (() => void)[] = [];

const notifyListeners = () => {
  listeners.forEach(listener => listener());
};

export const usePaymentProfilesSelection = () => {
  const [, forceUpdate] = useState({});
  
  const rerender = () => forceUpdate({});
  
  if (!listeners.includes(rerender)) {
    listeners.push(rerender);
  }

  const setSelectedRecords = (records: PaymentProfile[]) => {
    selectedRecords = records;
    notifyListeners();
  };

  const clearSelection = () => {
    selectedRecords = [];
    notifyListeners();
  };

  return {
    selectedRecords,
    setSelectedRecords,
    clearSelection,
    handleClearSelection: clearSelection,
    hasSelection: selectedRecords.length > 0
  };
};